import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mma_4b44c",
  "use": "mma_4b44c-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"mma_4b44c\">\n    <path fill=\"#d2221f\" d=\"M16.3 1.1H7.6L1.4 7.3v8.8l6.2 6.2h8.7l6.2-6.2V7.3z\" />\n    <path fill=\"#224293\" d=\"M.3 8.9h23.3v5.7H.3z\" />\n    <path d=\"M2.7 10.5v2.9h1.5v-2.6h.9v2.6h1.5v-2.6h1v2.6H9V10H2.1zm7.2 0v2.9h1.4v-2.6h1v2.6h1.5v-2.6h.9v2.6h1.5V10H9.3zm6.5-.5l.6.5v3h1.5v-1.1H20v1.1h1.5V10h-5.1zm3.6 1.5h-1.6v-.6H20v.6z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol